import { get } from 'lodash'

import { PAGINATION } from '../../common/constants'

const getPaginationForDictionaryType = (
  queryParams,
  dictionaryType,
  userPageSize,
) =>
  get(queryParams, dictionaryType.shortName, [
    PAGINATION.DEFAULT_PAGE,
    userPageSize || PAGINATION.DEFAULT_PAGE_SIZE,
  ])

export default getPaginationForDictionaryType
